// eslint-disable-next-line import/prefer-default-export
export const NAMED_ROUTES = {
  NotFound: '/not-found',
  Login: '/login',
  ResetPassword: '/reset-password',
  SignUp: '/sign-up',
}
